<template lang="html">
  <tr>
    <th scope="row" style="width:20%;">
      <div class="form-group position-relative" id="name1">
        <!-- <input type="text" name="time"  class="form-control" placeholder="" required="" @blur.stop.prevent="getFormData" v-model="date" @click.stop.prevent="showDatepicker" readonly> -->
        <month-picker v-on:getChildDate="catchChildDate"></month-picker>
        <!-- <date-picker v-bind:show="datepickerShow" v-on:getChildDate="catchChildDate"></date-picker> -->
      </div>
    </th>
    <td>
      <div class="form-group">
        <input type="text" name="place" class="form-control" placeholder="" required="" v-model="place"
          @blur.stop.prevent="getFormData">
      </div>
    </td>
    <td>
      <div class="form-group">
        <input type="text" name="publish" class="form-control" placeholder="" required="" v-model="company"
          @blur.stop.prevent="getFormData">
      </div>
    </td>
    <td>
      <div class="form-group">
        <input type="text" name="company" class="form-control" placeholder="" required="" v-model="publish"
          @blur.stop.prevent="getFormData">
      </div>
    </td>
    <td>
      <div class="form-group">
        <input type="text" name="work" class="form-control" placeholder="" required="" v-model="work"
          @blur.stop.prevent="getFormData">
      </div>
    </td>
    <td>
      <span class="remove" @click="remove">-</span>
    </td>
  </tr>
</template>

<script>
import datePicker from './datepicker.vue'
import monthPicker from './monthpicker.vue'
export default {
  name: 'step2',
  props: ["index"],
  data() {
    return {
      date: '日期',
      datepickerShow: false,
      place: '',
      publish: '',
      company: '',
      work: '',

    }
  },
  components: {
    datePicker,
    monthPicker
  },
  methods: {
    remove() {
      let index = this.index
      this.$emit('getRemoveIndex', index)
    },
    getFormData() {
      let index = this.index
      let formData = []
      formData[index] = {
        date: this.date,
        place: this.place,
        organizer: this.company,
        press: this.publish,
        awards: this.work
      }
      this.$emit('getFormData', { formData, index: index })
    },
    catchChildDate(date) {
      this.date = date.date
      if (date.date) {
        this.getFormData()
      }

      // this.datepickerShow = false
    },
    showDatepicker() {
      this.datepickerShow = !this.datepickerShow
    }
  },
  mounted() {
    document.body.addEventListener('click', (e) => {
      this.datepickerShow = false
    })
  }
}
</script>

<style lang="css">
.form-control[readonly] {
  background: none !important;
}

.remove {
  background: #18a689;
  color: #fff;
  width: 25px;
  height: 25px;
  line-height: 22px;
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  font-size: 25px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/step2.vue